// AB-Modul: Shell/Dashboard/Monitoring/Posteingang (Welle "UI-Paritaet", Agent FE-1).
// Praefix bleibt 'ab.' (flaches Woerterbuch, Monorepo-Konvention) — physisch getrennt von
// ab.de.js/ab.en.js (Datei-Eigentuemer dieser Welle: niemand darf sie anfassen), daher eigener
// Unter-Namespace 'ab.shell.*' fuer alle NEUEN Keys dieser Datei (keine Kollisionsgefahr).
const abShell = {
  // ---- Sidebar-Navigation ----
  'ab.shell.navDashboard': 'Dashboard',
  'ab.shell.navDocuments': 'Dokumente',
  'ab.shell.navMonitoring': 'Monitoring',

  // ---- Synchronisieren (Kopfleiste) ----
  'ab.shell.syncButton': 'Synchronisieren',
  'ab.shell.syncBusy': 'Synchronisiere…',
  'ab.shell.syncNoRunYet': 'Noch kein Sync',
  'ab.shell.syncLastRun': 'Letzter Sync {when}',
  'ab.shell.syncNewCount': '{n} neu',
  'ab.shell.syncFailed': 'fehlgeschlagen',
  'ab.shell.syncDisabledInfo': 'Mail-Eingang ist nicht konfiguriert.',
  'ab.shell.timeJustNow': 'gerade eben',
  'ab.shell.timeMinAgo': 'vor {n} Min',
  'ab.shell.timeHoursAgo': 'vor {n} Std',
  'ab.shell.timeDaysAgo': 'vor {n} Tg',

  // ---- Melden-Flag (eigene Meldungen) ----
  'ab.shell.myReportsTitle': 'Meine Meldungen',
  'ab.shell.myReportsAriaLabel': 'Meine Meldungen ({n} offen)',
  'ab.shell.myReportsSubtitle': 'Von dir zur Prüfung gemeldete Dokumente',
  'ab.shell.myReportsTabAll': 'Alle',
  'ab.shell.myReportsTabOpen': 'Offen',
  'ab.shell.myReportsTabDone': 'Erledigt',
  'ab.shell.myReportsOpen': 'Offen',
  'ab.shell.myReportsDone': 'Erledigt',
  'ab.shell.myReportsEmpty': 'Du hast noch keine Dokumente gemeldet. Melden kannst du ein Dokument in der Detailansicht über den Button „Melden".',
  'ab.shell.myReportsLoadError': 'Meldungen konnten nicht geladen werden',
  'ab.shell.myReportsReportedOn': 'Gemeldet am {date}',
  'ab.shell.myReportsHistory': 'Verlauf',
  'ab.shell.myReportsNoComments': 'Keine Kommentare.',
  'ab.shell.commentKind.report': 'gemeldet',
  'ab.shell.commentKind.resolve': 'gelöst',
  'ab.shell.commentKind.comment': 'Kommentar',

  // ---- Benachrichtigungs-Glocke (KI-Regelset-Vorschlag-Jobs) ----
  'ab.shell.notifTitle': 'Benachrichtigungen',
  'ab.shell.notifEmpty': 'Keine neuen Benachrichtigungen.',
  'ab.shell.notifAckAll': 'Alle quittieren',
  'ab.shell.notifAck': 'Quittieren',
  'ab.shell.notifRunning': 'KI erstellt Regelset-Vorschlag für Dokument Nr. {id} … läuft im Hintergrund',
  'ab.shell.notifDone': 'KI-Vorschlag bereit für Dokument Nr. {id}',
  'ab.shell.notifDoneOpen': 'Dokument öffnen',
  'ab.shell.notifError': 'KI-Vorschlag für Dokument Nr. {id} fehlgeschlagen',

  // ---- Dashboard ----
  'ab.shell.dashTitle': 'Dashboard',
  'ab.shell.dashSubtitle': 'Posteingang & Verarbeitungsstatus auf einen Blick',
  'ab.shell.dashLoadError': 'Dashboard konnte nicht geladen werden',
  'ab.shell.heroOpen': '{n} Vorgänge offen',
  'ab.shell.heroClear': 'Alles erledigt',
  'ab.shell.kpiInbox': 'Posteingang',
  'ab.shell.kpiNoRuleset': 'Ohne Regelset',
  'ab.shell.kpiNeedsReview': 'Zur Freigabe',
  'ab.shell.kpiFailed': 'Fehler',
  'ab.shell.kpiTransferredToday': 'Heute übertragen',

  // ---- Posteingang-Panel (Dashboard) ----
  'ab.shell.inboxTitle': 'Posteingang',
  'ab.shell.inboxSearchPlaceholder': 'Posteingang durchsuchen…',
  'ab.shell.inboxLoadError': 'Posteingang konnte nicht geladen werden',
  'ab.shell.inboxEmptyOpen': 'Alles bearbeitet — keine offenen E-Mails.',
  'ab.shell.inboxEmptyDone': 'Noch keine erledigten E-Mails.',
  'ab.shell.inboxEmptySearch': 'Keine Treffer für „{q}".',
  'ab.shell.inboxNotConfigured': 'Mail-Eingang ist nicht konfiguriert.',
  'ab.shell.inboxNotConfiguredHint': 'Der automatische Mail-Abruf ist auf diesem System deaktiviert — Dokumente können weiterhin manuell hochgeladen werden.',
  'ab.shell.mailNoSubject': '(kein Betreff)',
  'ab.shell.mailStatus.claimed': 'Wird verarbeitet',
  'ab.shell.mailStatus.processed': 'Verarbeitet',
  'ab.shell.mailStatus.failed': 'Fehlgeschlagen',
  'ab.shell.mailStatus.ignored': 'Ignoriert',

  // ---- 7-Tage-Trend / Top-Lieferanten / Kennzahlen heute ----
  'ab.shell.trendTitle': '7-Tage-Trend',
  'ab.shell.trendReceived': 'Eingang',
  'ab.shell.trendTransferred': 'übertragen',
  'ab.shell.trendEmpty': 'Noch keine Daten.',
  'ab.shell.suppliersTitle': 'Top-Lieferanten',
  'ab.shell.suppliersSubtitle': 'letzte 7 Tage',
  'ab.shell.suppliersEmpty': 'Keine Belege in den letzten 7 Tagen.',
  'ab.shell.todayTitle': 'Kennzahlen heute',
  'ab.shell.todayReceived': 'Eingegangen',
  'ab.shell.todayExtracted': 'Erkannt',
  'ab.shell.todayApproved': 'Freigegeben',
  'ab.shell.todayRejected': 'Abgelehnt',
  'ab.shell.todayEmpty': 'Heute noch keine Verarbeitung.',

  // ---- Dokumente-Seite + Filter ----
  'ab.shell.documentsTitle': 'Dokumente',
  'ab.shell.documentsSubtitle': 'Alle erfassten Auftragsbestätigungen',
  'ab.shell.filterStatusAll': 'Alle',
  'ab.shell.filterSupplier': 'Lieferant',
  'ab.shell.filterSupplierAll': 'Alle Lieferanten',
  'ab.shell.filterSupplierNone': 'Ohne Lieferant',
  'ab.shell.filterFrom': 'Von',
  'ab.shell.filterTo': 'Bis',
  'ab.shell.filterCommitted': 'Übertragen',
  'ab.shell.filterCommittedAll': 'Alle',
  'ab.shell.filterCommittedYes': 'Übertragen',
  'ab.shell.filterCommittedNo': 'Nicht übertragen',
  'ab.shell.filterReset': 'Filter zurücksetzen',
  'ab.shell.reportedTooltip': 'Dieses Dokument wurde zur Prüfung gemeldet',

  // ---- Monitoring ----
  'ab.shell.monitoringTitle': 'Monitoring',
  'ab.shell.monitoringSubtitle': 'Verarbeitungs-Protokolle der Auftragsbestätigungs-Erfassung',
  'ab.shell.monNoAccess': 'Kein Zugriff — diese Seite ist nur für Administratoren.',
  'ab.shell.monTabMail': 'Mail',
  'ab.shell.monTabExtraction': 'Extraktion',
  'ab.shell.monTabLlm': 'KI',
  'ab.shell.monTabActions': 'Aktionen',
  'ab.shell.monTabReported': 'Gemeldet',
  'ab.shell.monEmpty': 'Keine Einträge gefunden.',
  'ab.shell.monLoadError': 'Daten konnten nicht geladen werden',
  'ab.shell.monOpen': 'öffnen',
  'ab.shell.monColReceived': 'Empfangen',
  'ab.shell.monColStatus': 'Status',
  'ab.shell.monColSender': 'Absender',
  'ab.shell.monColSubject': 'Betreff',
  'ab.shell.monColReasonError': 'Grund / Fehler',
  'ab.shell.monColDocument': 'Dokument',
  'ab.shell.monColTime': 'Zeitpunkt',
  'ab.shell.monColEvent': 'Ereignis',
  'ab.shell.monColActor': 'Benutzer',
  'ab.shell.monColDetail': 'Detail',
  'ab.shell.monColStarted': 'Gestartet',
  'ab.shell.monColModel': 'Modell',
  'ab.shell.monColReported': 'Gemeldet',
  'ab.shell.monColReportedBy': 'Gemeldet von',
  'ab.shell.monColReportStatus': 'Meldestatus',
  'ab.shell.monResolve': 'Lösen',
  'ab.shell.monResolveDialogTitle': 'Meldung lösen?',
  'ab.shell.monResolveCommentPlaceholder': 'Kommentar zur Lösung…',
  'ab.shell.monResolveCommentRequired': 'Bitte einen Kommentar angeben',
  'ab.shell.monResolvedMsg': 'Meldung gelöst',
  'ab.shell.event.reported': 'Gemeldet',
  'ab.shell.event.report_resolved': 'Meldung gelöst',

  // ---- E-Mail-Detailansicht ----
  'ab.shell.mailDetailTitle': 'E-Mail',
  'ab.shell.mailDetailSender': 'Absender',
  'ab.shell.mailDetailReceived': 'Empfangen',
  'ab.shell.mailDetailStatus': 'Status',
  'ab.shell.mailDetailBody': 'E-Mail-Text',
  'ab.shell.mailDetailBodyEmpty': 'Kein E-Mail-Text gespeichert.',
  'ab.shell.mailDetailDocuments': 'Verknüpfte Dokumente',
  'ab.shell.mailDetailLoadError': 'E-Mail konnte nicht geladen werden',

  // ---- Generisch (Pager neue Listen) ----
  'ab.shell.pageInfo': 'Seite {page} von {totalPages} · {total} Treffer',
};

export default abShell;
